import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";

import styles from "./App.module.css";
import { setDimensionsRatio } from "./constants/utils";
import Welcome from "./screens/Welcome";
import Questionare from "./screens/Questionare";
import ScorePreparation from "./screens/ScorePreparation";
import SignUp from "./screens/SignUp";
import PhoneScreen from "./screens/PhoneScreen";

function PrctnApp() {
  useEffect(() => {
    setDimensionsRatio();
  }, []);

  return (
    <div className={styles.App}>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/questionare" element={<Questionare/>}/>
        <Route path="/score_prep" element={< ScorePreparation/>}/>
        <Route path="/signup" element={<SignUp/>}/>
        <Route path="/phone_screen" element={<PhoneScreen/>}/>
      </Routes>
    </div>
  );
}

export default PrctnApp;
